export const env = { ...process.env };
